module.exports = __webpack_public_path__ + "static/media/La_Republica.a05b76cc.svg";